import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Attribute, BasketItem } from '../../../../types/basket';
import { config } from '../../../../utils/config';
import Link from '../../../atoms/Link';
import './style.scss';

type ProductDetailsProps = {
  item: BasketItem;
  href: string;
};

const getAttributeText = ({ label, value }: Attribute) => {
  if (label.clientProvided?.trim() === '' || label.translationKey === 'unset') {
    return value;
  } else if (label.translationKey) {
    return (
      <>
        <FormattedMessage id={`basket.item.attribute.${label.translationKey}`} />: {value}
      </>
    );
  } else {
    return `${label.clientProvided}: ${value}`;
  }
};

const ProductDetails = ({ item, href }: ProductDetailsProps) => {
  const { hasDisabledLinks } = config.basket;
  const {
    id,
    displayData: { identifier, attributes }
  } = item;

  const isAmazonPayReviewPage = !!new URLSearchParams(window.location.search).get('isAmazonPayReviewPage');

  return (
    <div className="product-details">
      <Link
        className={classNames('product-details__section', 'product-details__section--name-and-attributes')}
        href={href}
        isDisabled={hasDisabledLinks || isAmazonPayReviewPage}
      >
        {identifier.value && (
          <p className="product-details__identifier" data-test-id="item-identifier">
            {identifier.value}
          </p>
        )}
        {attributes && (
          <ul className="product-details__attributes" data-test-id="item-attributes">
            <>
              {attributes.map(attribute => (
                <li key={attribute.label.translationKey ?? attribute.label.clientProvided}>
                  {getAttributeText(attribute)}
                </li>
              ))}
            </>
          </ul>
        )}
      </Link>
      <slot name={`slot_basket_item_details_${id}`} />
    </div>
  );
};

export default ProductDetails;
